import { Modal, Form, Space, Button, Row, Col } from "antd";
import { useForm } from "react-hook-form";
import SearchSelectEx from "../shared/form/SearchSelectEx";
import CustomInputTextArea from "../shared/form/reactHookForm/CustomInputTextArea";
import { yupResolver } from "@hookform/resolvers/yup";

import { changeStatusSchema } from "./manageRemindersSchemas";

const ChangeStatusModal = ({ isOpen, onCancel, onSave, selected, loading }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty, isValid }, // Add formState destructuring
  } = useForm({
    defaultValues: {
      Status: selected?.RequestStatus,
      ProcessingStage: selected?.LatestProcessingStage,
      Notes: "",
    },
    resolver: yupResolver(changeStatusSchema),
    mode: "onChange", // Add this to validate on change
  });

  const statusOptions = [
    { value: 0, label: "Reminder Sent", disabled: true },
    { value: 1, label: "Waiting For Response", disabled: true },
    { value: 2, label: "Processing" },
    { value: 3, label: "Cancelled", disabled: true },
    { value: 4, label: "Opted Out" },
    { value: 5, label: "Customer Request Resolved" },
    { value: 6, label: "Waiting On Customer" },
    { value: 7, label: "No Phone / Email", disabled: true },
    { value: 9, label: "Lost", disabled: true },
  ];

  const processingStageOptions = [
    { value: 0, label: "None" },
    { value: 1, label: "Agent Assigned", disabled: true },
    { value: 2, label: "Phone Call Made" },
    { value: 6, label: "Customer Indicated Renewal" },
    { value: 7, label: "Policy Renewed (Verified)" },
    { value: 8, label: "Callback Requested", disabled: true },
    { value: 3, label: "Reminder Letter Sent" },
    { value: 4, label: "Delivery Booked" },
    { value: 5, label: "Other" },
  ];

  const onSubmit = (data) => {
    onSave(data);
    reset();
  };

  const handleCancel = () => {
    reset();
    onCancel();
  };

  return (
    <Modal
      title="Change Status"
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose={true}
    >
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        <SearchSelectEx
          formLabel="Reminder Status"
          name="Status"
          control={control}
          required={true}
          options={statusOptions}
          placeholder="Select Status"
        />

        <SearchSelectEx
          formLabel="Processing Stage"
          name="ProcessingStage"
          control={control}
          required={true}
          options={processingStageOptions}
          placeholder="Select Processing Stage"
        />

        <CustomInputTextArea
          formLabel="Notes"
          name="Notes"
          control={control}
          required={true}
          rows={2}
          maxLength={120}
        />

        <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Space>
              <Button onClick={handleCancel}>Cancel</Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={!isDirty || !isValid}
              >
                Save
              </Button>
            </Space>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangeStatusModal;
